module.exports = __webpack_public_path__ + "static/media/eshop-gerner-ruka.36393d22.png";